import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'basic-card',
  templateUrl: './basic-card.component.html',
  styleUrls: ['./basic-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BasicCardComponent {
  @Input() public title: string = '';
  @Input() public subtitle: string;
  @Input() public loading: boolean;
  @Input() public error: string;
}
